import { FormFileInput, FormInput, Loader } from "@/components";
import useAddEdit from "./useAddEdit";
import { FormProvider } from "react-hook-form";
import {
  Button,
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
} from "@/components/ui";
import { X } from "lucide-react";
import { capitalize } from "@/lib/utils";
import { NAME, UPLOAD } from "./consts";

const AddEdit = () => {
  const {
    form,
    onSubmit,
    requiredFields,
    isView,
    onCancel,
    isAddPending,
    isMobile,
    uploadRef,
    isAddImagePending,
    action,
    isUpdatePending,
    isEdit,
  } = useAddEdit();
  const { errors } = form.formState;

  return (
    <Drawer open={true} direction={isMobile ? "bottom" : "right"}>
      <DrawerContent className="px-6 lg:min-w-[500px] xl:min-w-[730px]">
        <DrawerHeader className="px-0">
          <div className="flex items-center justify-between">
            <DrawerTitle className="text-[20px]">
              {capitalize(action || "")}
            </DrawerTitle>
            <X
              onClick={onCancel}
              className="cursor-pointer stroke-g-300 hover:stroke-g-400"
            />
          </div>
        </DrawerHeader>

        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <div className="bg-white rounded-lg py-[25px] px-1">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-[30px]">
                <FormInput
                  name={NAME}
                  control={form.control}
                  label="Title"
                  placeholder="Please enter"
                  error={errors[NAME]?.message}
                  isRequired={requiredFields.includes(NAME)}
                  disabled={isView}
                />
                <FormFileInput
                  fileInputRef={uploadRef}
                  name={UPLOAD}
                  control={form.control}
                  label="Upload"
                  placeholder="Please enter"
                  error={errors[UPLOAD]?.message}
                  isRequired
                  disabled={isView}
                  accept="application/pdf"
                />
              </div>
            </div>
            <div className="flex flex-row justify-end gap-3 py-3">
              <Button
                variant="outline"
                type="button"
                onClick={onCancel}
                disabled={isAddPending || isAddImagePending || isUpdatePending}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                disabled={isAddPending || isAddImagePending || isUpdatePending}
              >
                {isAddPending ||
                  isAddImagePending ||
                  (isUpdatePending && <Loader variant="secondary" />)}
                {isEdit ? "Update" : "Submit"}
              </Button>
            </div>
          </form>
        </FormProvider>
      </DrawerContent>
    </Drawer>
  );
};

export default AddEdit;
